import React from 'react';
import { nanoid } from 'nanoid';
import { StaticImage } from 'gatsby-plugin-image';
import { Box, Grid, GridItem } from '@chakra-ui/react';
import SectionTitle from '../../components/shared/SectionTitle';

const LOGOS: React.ReactNode[] = [
  <StaticImage
    placeholder="blurred"
    src="../../images/01comfort.webp"
    alt="Comfort logo"
  />,
  <StaticImage
    placeholder="blurred"
    src="../../images/02erie.jpeg"
    alt="Erie logo"
  />,
  <StaticImage
    placeholder="blurred"
    src="../../images/FMNE-New-Logo-horizontal-2018.webp"
    alt="Farmer's Mutual logo"
  />,
  <StaticImage
    placeholder="blurred"
    src="../../images/04kearns.webp"
    alt="Kearns logo"
  />,
  <StaticImage
    placeholder="blurred"
    src="../../images/05feazel.webp"
    alt="Feazel logo"
  />,

  <StaticImage
    placeholder="blurred"
    src="../../images/06triton.jpeg"
    alt="Triton logo"
  />,
  <StaticImage
    placeholder="blurred"
    src="../../images/07shield.webp"
    alt="Shield logo"
  />,
  <StaticImage
    placeholder="blurred"
    src="../../images/08ridge.webp"
    alt="Bridge logo"
  />,
  <StaticImage
    placeholder="blurred"
    src="../../images/09twin.webp"
    alt="Twin logo"
  />,
  <StaticImage
    placeholder="blurred"
    src="../../images/10craftsman.webp"
    alt="Craftsman logo"
  />,
  <StaticImage
    placeholder="blurred"
    src="../../images/11hoffman.webp"
    alt="Hoffman logo"
  />,
  <StaticImage
    placeholder="blurred"
    src="../../images/12northern.webp"
    alt="Northern logo"
  />,
];

const CustomerLogoGrid = () => (
  <Box maxW="8xl" mx="auto" px="5" my="32">
    <SectionTitle title="Companies use HOVER to save time, establish credibility and grow their business." />
    <Grid
      maxW="7xl"
      mx="auto"
      my="10"
      templateColumns="repeat(3, 1fr)"
      justifyContent="center"
      columnGap={[5, 20]}
      rowGap={[5, 20]}
      px={[2, 9]}
    >
      {LOGOS.map(image => (
        <GridItem
          key={nanoid()}
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          {image}
        </GridItem>
      ))}
    </Grid>
  </Box>
);

export default CustomerLogoGrid;
